import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { lastValueFrom, BehaviorSubject, Subject } from 'rxjs';

import { MentionDocument } from '../../data/models/mention.model';

interface MentionDictionary {
  [key: string]: MentionDocument[];
}

@Injectable({
  providedIn: 'root'
})
export class ListMentionsService {
  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {}

  private unreadMentionsExistSubject = new BehaviorSubject<boolean>(false);
  public unreadExist$ = this.unreadMentionsExistSubject.asObservable();

  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  _genDefaultHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  public async listMentionsByDialogs(dialogIds: string[]): Promise<MentionDictionary> {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = this._genDefaultHeader();
    headers = headers.set('LoginUserId', loginUserId);

    const dialogIdStr = dialogIds.join(',');

    let params = new HttpParams();
    params = params.set('dialogIds', dialogIdStr);

    const url = `${apiConfig.uri}/licence/${sectionId}/mentions`;

    var result = await lastValueFrom(
      this.httpClient.get<MentionDictionary>(url, {
        headers: headers,
        params: params
      })
    );

    return result;
  }

  public async listMentionsToCurrentLoginUser(isRead: boolean | null): Promise<MentionDocument[]> {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);
    loginUserId = loginUserId.replace(/^"|"$/g, '');

    let headers = this._genDefaultHeader();
    headers = headers.set('LoginUserId', loginUserId);

    let params = new HttpParams();
    params = params.set('mentionToUserId', loginUserId);
    if (isRead != null) {
      params = params.set('isRead', isRead.toString());
    }

    const url = `${apiConfig.uri}/licence/${sectionId}/mentions`;

    var result = await lastValueFrom(
      this.httpClient.get<MentionDocument[]>(url, {
        headers: headers,
        params: params
      })
    );

    return result;
  }

  public async isUnreadMentionsExist(): Promise<boolean> {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);
    loginUserId = loginUserId.replace(/^"|"$/g, '');

    let headers = this._genDefaultHeader();
    headers = headers.set('LoginUserId', loginUserId);

    let params = new HttpParams();
    params = params.set('mentionToUserId', loginUserId);
    params = params.set('isRead', false.toString());

    const url = `${apiConfig.uri}/licence/${sectionId}/mentions`;

    var result = await lastValueFrom(
      this.httpClient.get<MentionDocument[]>(url, {
        headers: headers,
        params: params
      })
    );

    const isExist = result.length > 0;

    this.unreadMentionsExistSubject.next(isExist);
    this.unreadCountSubject.next(result.length);

    return isExist;
  }
}
